/* PoB service booking: a presentation layer over the Relay panel. It never talks to Relay.
   It only restyles what the panel renders (the panel's own selects stay in the page and stay in charge),
   so if this file fails to load or the panel markup changes, the plain panel still works. */
(function () {
  'use strict';
  var root = document.getElementById('relay-picker');
  if (!root || !window.MutationObserver) return;
  var book = root.closest('.pob-book') || document.body;
  var data = {};
  try { data = JSON.parse(document.getElementById('relay-product').textContent) || {}; } catch (e) { data = {}; }
  var variants = Array.isArray(data.variants) ? data.variants : [];
  var optNames = (Array.isArray(data.options) ? data.options : []).map(function (o) {
    return typeof o === 'string' ? o : (o && o.name) || '';
  });
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function el(tag, attrs) {
    var n = document.createElement(tag), k, i;
    for (k in (attrs || {})) n.setAttribute(k, attrs[k]);
    for (i = 2; i < arguments.length; i++) if (arguments[i] != null) n.append(arguments[i]);
    return n;
  }
  function setText(n, t) { if (n.textContent !== t) n.textContent = t; }
  function money(c) { return c % 100 === 0 ? '$' + c / 100 : '$' + (c / 100).toFixed(2); }
  function kindOf(sel) {
    var m = /:\s*(.+)$/.exec(sel.getAttribute('aria-label') || '');
    return m ? m[1].trim() : '';
  }
  function findVariant(vals) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.option1 === vals[0] && (vals.length < 2 || v.option2 === vals[1]) && (vals.length < 3 || v.option3 === vals[2])) return v;
    }
    return null;
  }

  var LABELS = { bike: 'Bike', level: 'Service level', electric: 'Electric bike?' };

  /* ---------- step 1: bike, level, electric ---------- */
  function currentVals(fs) {
    var vals = [];
    [].forEach.call(fs.querySelectorAll('select[aria-label]'), function (s) {
      var i = optNames.indexOf(kindOf(s));
      if (i > -1) vals[i] = s.value;
    });
    return vals;
  }

  function buildGroup(fs, sel) {
    var name = kindOf(sel), key = name.toLowerCase(), idx = optNames.indexOf(name);
    if (idx < 0 || !sel.options.length) return;
    var isLevel = key === 'level';
    var box = el('div', { 'class': isLevel ? 'pob-lv' : 'pob-seg', role: 'radiogroup', 'aria-label': sel.getAttribute('aria-label') });
    [].forEach.call(sel.options, function (o) {
      var b = el('button', { type: 'button', role: 'radio', 'data-v': o.value, 'aria-checked': 'false', tabindex: '-1' });
      if (isLevel) {
        var k = o.value.split(' ')[0].toLowerCase();
        var line = book.getAttribute('data-line-' + k) || '';
        var n = el('span', { 'class': 'pob-lv__n' }, o.value);
        if (book.getAttribute('data-popular') === o.value) n.append(el('span', { 'class': 'pob-lv__f' }, book.getAttribute('data-popular-label') || 'Most popular'));
        b.append(n, el('span', { 'class': 'pob-lv__p' }), el('span', { 'class': 'pob-lv__d' }, line));
      } else {
        b.append(el('span', { 'class': 'pob-seg__t' }, o.text));
      }
      b.addEventListener('click', function () {
        if (sel.value !== o.value) {
          sel.value = o.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        refresh(fs);
      });
      box.append(b);
    });
    box.addEventListener('keydown', function (e) {
      var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      if (!keys[e.key]) return;
      var bs = [].slice.call(box.querySelectorAll('button')), i = bs.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      var nb = bs[(i + keys[e.key] + bs.length) % bs.length];
      nb.focus(); nb.click();
    });
    var grp = el('div', { 'class': 'pob-opt-group', 'data-kind': key, 'data-sel': sel.id },
      el('span', { 'class': 'pob-opt-group__label', 'aria-hidden': 'true' }, LABELS[key] || name), box);
    if (isLevel) {
      var more = el('a', { 'class': 'pob-lv__more', href: '#pob-levels' }, 'What each level includes');
      more.addEventListener('click', function () {
        var d = document.getElementById('pob-levels');
        if (d) { d.open = true; }
      });
      grp.append(more);
    }
    sel.insertAdjacentElement('afterend', grp);
    sel.classList.add('pob-sr');
    var lab = fs.querySelector('label[for="' + sel.id + '"]');
    if (lab) lab.classList.add('pob-sr');
  }

  function refresh(fs) {
    var vals = currentVals(fs);
    [].forEach.call(fs.querySelectorAll('.pob-opt-group'), function (g) {
      var sel = document.getElementById(g.getAttribute('data-sel'));
      if (!sel) return;
      var idx = optNames.indexOf(kindOf(sel)), key = g.getAttribute('data-kind');
      var bs = [].slice.call(g.querySelectorAll('button[role=radio]')), any = false;
      bs.forEach(function (b) {
        var on = b.getAttribute('data-v') === sel.value;
        if (on) any = true;
        if (b.getAttribute('aria-checked') !== String(on)) b.setAttribute('aria-checked', String(on));
        var ti = on ? '0' : '-1';
        if (b.getAttribute('tabindex') !== ti) b.setAttribute('tabindex', ti);
        var test = vals.slice(); test[idx] = b.getAttribute('data-v');
        var v = findVariant(test);
        if (key === 'level') {
          setText(b.querySelector('.pob-lv__p'), v && v.available !== false ? money(Math.round(v.price)) : 'Call us');
        } else if (key === 'electric' && /^yes/i.test(b.getAttribute('data-v'))) {
          var off = vals.slice(); off[idx] = (sel.options[0] || {}).value;
          var base = findVariant(off), diff = v && base ? Math.round(v.price - base.price) : 0;
          setText(b.querySelector('.pob-seg__t'), diff > 0 ? 'Yes, e-bike (+' + money(diff) + ')' : 'Yes, e-bike');
        }
      });
      if (!any && bs[0]) bs[0].setAttribute('tabindex', '0');
    });
  }

  var deepLinked = false;
  function applyDeepLink(fs) {
    if (deepLinked) return;
    deepLinked = true;
    var q = new URLSearchParams(location.search);
    [].forEach.call(fs.querySelectorAll('select[aria-label]'), function (s) {
      var want = q.get(kindOf(s).toLowerCase());
      if (!want) return;
      for (var i = 0; i < s.options.length; i++) {
        if (s.options[i].value.toLowerCase() === want.toLowerCase()) {
          s.value = s.options[i].value;
          s.dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    });
  }

  /* ---------- step 2: days and times ---------- */
  function tidyChips() {
    [].forEach.call(root.querySelectorAll('.rp-row[aria-label="Day"] button'), function (b) {
      if (b.getAttribute('data-pob')) return;
      b.setAttribute('data-pob', '1');
      var t = b.textContent.trim(), p = t.split(' ');
      b.setAttribute('aria-label', t);
      b.textContent = '';
      b.append(el('span', { 'class': 'pob-day__w', 'aria-hidden': 'true' }, p[0]), el('span', { 'class': 'pob-day__d', 'aria-hidden': 'true' }, p.slice(1).join(' ')));
    });
    [].forEach.call(root.querySelectorAll('.rp-row[aria-label="Time"] button'), function (b) {
      if (b.getAttribute('data-pob')) return;
      b.setAttribute('data-pob', '1');
      var t = b.textContent.trim(), p = t.split(' · ');
      b.setAttribute('aria-label', p.length > 1 ? p[0] + ', premium time ' + p[1].replace('+', 'plus ') : t);
      b.textContent = '';
      b.append(el('span', { 'class': 'pob-time__t', 'aria-hidden': 'true' }, p[0]));
      if (p[1]) b.append(el('span', { 'class': 'pob-prem', 'aria-hidden': 'true' }, p[1] + ' premium'));
    });
    [].forEach.call(root.querySelectorAll('.rp-msg'), function (m) {
      var ok = /held for you/i.test(m.textContent);
      if (ok && !m.classList.contains('pob-ok')) m.classList.add('pob-ok');
    });
  }

  /* ---------- stepper ---------- */
  var steps = document.querySelector('[data-pob-steps]'), lastStep = 0;
  function currentStep() {
    if (root.querySelector('#rp-address')) return 1;
    if (root.querySelector('.rp-row[aria-label="Day"]')) return 2;
    return 3;
  }
  function paintSteps() {
    var s = currentStep();
    if (steps) {
      [].forEach.call(steps.children, function (li, i) {
        if (i + 1 === s) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
        if (i + 1 < s) li.setAttribute('data-done', ''); else li.removeAttribute('data-done');
      });
    }
    if (lastStep && s !== lastStep) {
      var card = root.closest('.pob-book__card') || root;
      if (card.getBoundingClientRect().top < 0) card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
    lastStep = s;
  }

  function enhance() {
    [].forEach.call(root.querySelectorAll('fieldset'), function (fs) {
      var fresh = false;
      [].forEach.call(fs.querySelectorAll('select[aria-label]'), function (sel) {
        if (sel.getAttribute('data-pob')) return;
        sel.setAttribute('data-pob', '1');
        try { buildGroup(fs, sel); fresh = true; } catch (e) { /* leave the plain select in place */ }
      });
      if (fresh && fs === root.querySelector('fieldset')) applyDeepLink(fs);
      refresh(fs);
    });
    tidyChips();
    paintSteps();
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; try { enhance(); } catch (e) { /* plain panel keeps working */ } });
  }).observe(root, { childList: true, subtree: true });
  try { enhance(); } catch (e) { /* plain panel keeps working */ }
})();